export default {
  routes: [
    {
      name: 'exportedFiles',
      path: '/directory/exported-files',
      component: () => import('./views/TheExportedFilesPages.vue'),

    },

    {
      name: 'exportedFile',
      path: '/directory/exported-files/:uuid',
      component: () => import('./views/TheExportedFilesPage.vue'),
    },
  ]
}
